import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {BehaviorSubject, tap} from "rxjs";

export interface LoginResponse {
  status: number;
  user: any;
  token: string;
}

export interface ConsentData {
  companyName: string;
  email: string;
  createdAt?: string;
  updatedAt?: string;
  status: 'DRAFT' | 'SUBMITTED';
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private currentUserSubject = new BehaviorSubject<any | null>(null);
  connectedGroup = '';
  currentUser$ = this.currentUserSubject.asObservable();

  constructor(private http: HttpClient) {
    // Vérifier si on a déjà des données en session
    const storedUser = sessionStorage.getItem('currentUser');
    if (storedUser && storedUser !== 'undefined') {
      this.currentUserSubject.next(JSON.parse(storedUser));
    }
  }

  login(data: any, group: string) {
    data['group'] = group;
    return this.http.post<LoginResponse>(`${environment.api_url}/onboarding_v2`, {...data, action: 'login'}).pipe(
      tap(response => {
        this.connectedGroup = group;
        sessionStorage.setItem('currentUser', JSON.stringify(response.user));
        localStorage.setItem('access_token', response.token)
        this.currentUserSubject.next(response.user);
      })
    );
  }

  getGroup() {
    return this.connectedGroup;
  }

  getCurrentUserData(): any | null {
    return this.currentUserSubject.value;
  }

  public get currentUserValue() {
    return this.currentUserSubject.value;
  }

  isLoggedIn(): boolean {
    return this.currentUserValue !== null;
  }

  getToken(): string | null {
    return localStorage.getItem('access_token');
  }

  logout(): void {
    // Remove user and token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('currentUser');

    // Reset the BehaviorSubject
    this.currentUserSubject.next(null);
  }

}
